import {useAppSelector} from "../../feature/tools";
import {useEffect, useState} from "react";

export const IconBoltGrad = (
    props: {
        style?: React.CSSProperties,
        className?: string,
        size?: number
        colorStart?: string
        colorMiddle?: string
        colorEnd?: string
    }
) => {
    const aiProviders = useAppSelector(state => state.aiSlice.projectAiProviderSettings)
    const [hasProviders, setHasProviders] = useState(aiProviders.length > 0 && aiProviders.flatMap(p => p.models).length > 0)

    useEffect(() => {
        setHasProviders(aiProviders.length > 0 && aiProviders.flatMap(p => p.models).length > 0)
    }, [aiProviders]);
    return (
        <svg
            style={{...props.style, width: props.size ?? props.style?.width ?? 12}}
            className={props.className}
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">

            {/*<defs>*/}
            {/*    <linearGradient id={`gradient-${rand}`} gradientTransform="rotate(75)">*/}
            {/*        <stop offset="0%" stopColor={props.colorStart ?? "#2c67f2"}/>*/}
            {/*        <stop offset="50%" stopColor={props.colorMiddle ?? props.colorStart ?? "#2c67f2"}/>*/}
            {/*        <stop offset="100%" stopColor={props.colorEnd ?? props.colorStart ?? "#2c67f2"}/>*/}
            {/*    </linearGradient>*/}
            {/*</defs>*/}
            <path
                // fill={`url(#gradient-${rand})`}
                fill={props.colorStart ?? (hasProviders ? "#2c67f2" : "#ccc")}
                d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z"/>
        </svg>)
}